export const styles = {
  group: {
    backgroundColor: 'accentFade.main',
    px: 2,
    py: 1.5,
    display: 'flex',
    gap: 2,
  },
  row: {
    '.MuiAutocomplete-option': {
      py: 1.5,
    },
  },
};
